import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { setJsonLd } from "../seo/pageMeta";
import { faqJsonLd } from "../seo/structuredData";
import { Landing, trustPoints } from "./landingPages";
import ProductVideo from "../Components/ProductVideo";
import { LANDING_VIDEOS } from "../Components/productVideos";
import "../leasing.css";
import "../landing.css";

export default function LandingPage({ page }: { page: Landing }) {
  useEffect(() => {
    setJsonLd("faq", faqJsonLd(page.faqs));
    return () => setJsonLd("faq", null);
  }, [page]);
  return <main className="lease-page landing-page">
    <section className="lease-hero"><div className="lease-wrap lease-hero-grid"><div>
      <p className="lease-eyebrow">{page.eyebrow}</p>
      <h1>{page.heading}{" "}<br /><span>{page.highlight}</span></h1>
      <p className="lease-lead">{page.lead}</p>
      <div className="lease-actions"><Link className="lease-button" to={page.primary.to}>{page.primary.label}</Link><Link to={page.secondary.to}>{page.secondary.label}</Link></div>
    </div><figure><img src={page.image.src} alt={page.image.alt} /><figcaption>A Technogenious gaming machine installation in Jamaica.</figcaption></figure></div></section>

    {LANDING_VIDEOS[page.path] && <div className="lease-wrap"><ProductVideo video={LANDING_VIDEOS[page.path]} /></div>}
    <section className="lease-wrap lease-section" aria-labelledby="landing-offer">
      <h2 id="landing-offer">{page.offerHeading}</h2>
      <p className="lease-intro">{page.offerIntro}</p>
      <div className="landing-offers">{page.offers.map(([title, text]) => <article key={title}><span className="lease-mark" aria-hidden="true">↗</span><h3>{title}</h3><p>{text}</p></article>)}</div>
    </section>

    <section className="lease-wrap landing-trust" aria-label="Why Technogenious">
      {trustPoints.map(([title, text]) => <div key={title}><strong>{title}</strong><p>{text}</p></div>)}
    </section>

    <section className="lease-wrap lease-section" aria-labelledby="landing-faq">
      <h2 id="landing-faq">Common questions</h2>
      <div className="landing-faqs">{page.faqs.map((f) => <details key={f.question}><summary>{f.question}</summary><p>{f.answer}</p></details>)}</div>
    </section>

    <section className="lease-wrap lease-contact">
      <p className="lease-eyebrow">TALK TO OUR KINGSTON TEAM</p>
      <h2>Ready when you are.</h2>
      <p>Call +1 (876) 648-4163, WhatsApp +1 (876) 448-2032, or visit us at Shop 4B, 17 Molynes Road, Kingston 10, Monday to Saturday, 9:00 am to 6:00 pm.</p>
      <div className="lease-actions"><a className="lease-button" href="https://wa.me/18764482032" target="_blank" rel="noreferrer">WhatsApp us ↗</a><Link className="lease-outline" to="/contact">Contact us →</Link></div>
      <nav className="landing-related" aria-label="Related pages"><span>See also:</span>{page.related.map((r) => <Link key={r.to} to={r.to}>{r.label}</Link>)}</nav>
    </section>
  </main>;
}
